import React from 'react';
import { StyledLogo, StyledRateFormContainer, StyledX, StyledButtonLink } from './stars.style';
import { ReactComponent as FixelLogo } from './FixelLogo.svg';
import { ReactComponent as Spark } from './Spark.svg';
import { ReactComponent as X } from './X.svg';

const GoodRateForm = ({ onClose }) => {
	const onSubmit = (e) => {
		e.preventDefault();
	};
	return (
		<StyledRateFormContainer onSubmit={onSubmit}>
			<StyledX onClick={onClose}>
				<X />
			</StyledX>
			<StyledLogo>
				<FixelLogo />
			</StyledLogo>
			<h2>Oh, I’m blushing!</h2>
			<h3>
				It would mean the world to us if you can also leave this review on the <b>app store</b>.
			</h3>
			<StyledButtonLink href='https://wordpress.org/plugins/fixel/#reviews' target='_blank' rel='noreferrer' onClick={onClose}>
				<Spark />
				Rate Us On App Store
			</StyledButtonLink>
		</StyledRateFormContainer>
	);
};

export default GoodRateForm;
